/* eslint-disable no-console */
import { DropdownOption } from '@/app/interfaces/filtersAdvanced';
import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter, signal } from '@angular/core';
import { DesyAngularModule } from 'desy-angular';

@Component({
  selector: 'app-multiselect',
  imports: [DesyAngularModule, CommonModule],
  templateUrl: './multiselect.component.html',
  styleUrls: ['./multiselect.component.scss'],
})
export class MultiselectComponent {
  @Output() select = new EventEmitter<string[] | number[]>();
  @Input() isMultiselectable: boolean = false;
  @Input() label: string = '';
  @Input() options: DropdownOption[] = [];
  @Input() selected: (string | number)[] = [];
  @Input() disabled = false;
  @Input() id: string = '';
  @Input() role: string = 'button';
  @Input() classes: string = '';
  @Input() labelClass: string = '';
  @Input() html: string = '';
  @Input() isRequired: boolean = false;

  selectedItems = signal<DropdownOption[]>([]);

  onItemChange($event: unknown) {
    console.log('[Evento de cambio de item multiselect]', $event);
  }
  selectedValues = signal<string[] | number[]>([]);
  touched = signal(false);
  isInvalid = signal(false);

  onSelect() {
    this.touched.set(true);

    this.selectedItems.set(this.options.filter((item) => item.check));
    this.selectedValues.set(this.selectedItems().map((item) => item.value));
    this.select.emit(this.selectedValues());
    if (this.isRequired && this.touched()) {
      this.isInvalid.set(this.selectedItems().length === 0);
    }

    console.log('[opciones seleccionadas]', this.selectedValues());
    console.log('[isInvalid]', this.isInvalid());
  }

  clearSelection(): void {
    this.options.forEach((item) => (item.check = false));
    this.onSelect(); // para que actualice selectedItems y emita el cambio
  }
}
